// inputsVisitas.js
import {
  validateRequired,
  validateLength,
  validateNonZeroInteger,
} from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Código Cliente",
    name: "cli_codigo",
    type: "text",
    placeholder: "Código del cliente", 
  },
  {
    id: 2,
    label: "Direccion ",
    name: "direccion",
    type: "text",
    placeholder: "Direccion y Numero", 
  },
  {
    id: 3,
    label: "Razon Social",
    name: "razon_social",
    type: "text",
    placeholder: "Razon Social", 
  },
  {
    id: 4,
    label: "Nombre de Fantasia",
    name: "cli_name",
    type: "text",
    placeholder: "Nombre de Fantasia", 
  },
  {
    id: 6,
    label: "Empleado (Vendedor)",
    name: "sel_id",
    type: "number",
    placeholder: "ID del vendedor", 
  },
   {
    id: 7,
    label: "Nombre Vendedor",
    name: "sel_name",
    type: "text",
    placeholder: "Nombre del Preventista", 
  },
  {
    id: 8,
    label: "Fecha de Visita",
    name: "fecha",
    type: "text",
    placeholder: "Seleccione fecha", 
  },
  {
    id: 9,
    label: "Distancia (metros)",
    name: "distancia_metros",
    type: "text",
    placeholder: "Distancia en metros", 
  },
  {
    id: 10,
    label: "Observación",
    name: "vis_observacion",
    type: "textarea", 
  },
 
];

export default Inputs;
